import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import { useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import { Ban } from "../../types";
import UserSearch from "./SearchScreen/User/User";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { UserSearchLoadin } from "./SearchScreen/User/UserSearchLoading";
import { EyeOff } from "react-feather";

const UserMutes = () => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [mutes, setMutes] = useState<Ban[] | null>(null);
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(() => 1);
    const { token } = useAuth();

    const loadData = async (newPage?: number) => {
        const currentPage = newPage ?? page + 1;
        const url = `${PACOCA_API_URL}/users/mutes?page=${currentPage}`;

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            const data = response.data;

            if (data.mutes.length > 0) {
                setMutes((prevData) => [...(prevData || []), ...data.mutes]);
            } else {
                setEnd(true);
            }
        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err);
            setMessage(messageError, type);
            console.error("Erro:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData(page);
    }, [page]);

    return (
        <>
            <Screen paddingTopTitle={true} title="Usuários Ocultados">
                <Helmet>
                    <title>Usuários Ocultados</title>
                    <meta name="description" content="Veja os usuários que você ocultou do seu feed" />
                    <meta name="keywords" content="ocultados, usuarios ocultados, ocultar, rede social, rede social brasileira" />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content="Paçoca - Usuários Ocultados" />
                    <meta property="og:description" content="Veja os usuários que você ocultou do seu feed" />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Paçoca - Usuários Ocultados" />
                    <meta name="twitter:description" content="Veja os usuários que você ocultou do seu feed" />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <UserSearchLoadin loading={loading} />

                {!loading && !mutes?.length ? (
                    <div className="user-select-none row row-empty-comment">
                        <span className="span-empty">
                            <EyeOff className="icon-empty" />
                            <h3 className="w-100 text-center">Nenhum usuário ocultado</h3>
                        </span>
                    </div>
                ) : null}

                {mutes?.map((mute, index) => (
                    <UserSearch hideFollowUser key={index} user={mute?.user} />
                ))}

                <p ref={endOfListRef}></p>
            </Screen>
        </>
    );
};

export default UserMutes;
